module.exports = __webpack_public_path__ + "static/media/17.86c0279e.jpg";